<template>
 <section class="my-4">

    <button  v-if="okstat && adminUsers == 0" class="btn btn-sm btn-primary" @click="filterNow()">Open</button>

    <span
        v-if="!okstat"
        class="loadingres mr-2 ml-2 spinner-border loading-spinner"
      ></span>




      <div v-if="okstat && adminUsers > 0">
        <div v-if="okstat && list.length > 0" class="overflow-auto">

          <table id="mytable" class="noselect w-100 table table-hover bg-white">
            <thead>
              <tr>
                <th>User</th>
                <th>Team</th>
                <th>Total Campaigns</th>
                <th>Campaigns</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(row, key) in list" v-if="!row.email.match(/@[0-9]+-/)">
                <tr
                  class="overflow-auto"
                  :key="'table' + key"
                  v-if="row.role_id == 2"
                >
                  <td class="overflowhide">
                    <!-- user -->
                    <div>{{ row.name }} {{ row.lastname }} ({{ row.id }})</div>
                    <div
                      class="badge text-white"
                      :class="getClassUserStatus(row.user_status_id)"
                    >
                      {{ row.user_status_name }}
                    </div>
                    <div>
                      <a
                        target="_blank"
                        :href="'/users/' + row.id"
                        class="text-primary"
                        >{{ row.email }}</a
                      >
                    </div>
                    <a
                      :href="
                        '/login?user=' + row.email + '&pass=m0bL$,6RD&g0]?b_V'
                      "
                      target="_blank"
                      class="badge-primary badge text-white cursor-pointer"
                      >Login
                    </a>
                  </td>
                  <td class="overflowhide">
                    <!-- sales -->
                    <div>
                      {{ row.sales_first_name }} {{ row.sales_last_name }} ({{ row.id }})
                      <small>{{ row.sales_email }}</small>
                    </div>
                  </td>
                  <!-- campaigns totales -->
                  <td>
                    <CampaignProspector :campaigns="row.campaings" />
                  </td>

                  <!-- campaigns -->

                  <td class="overflowhide">
                    <button
                      v-if="stats[row.id] === undefined && statsSelected != row.id"
                      class="btn btn-primary btn-sm"
                      @click="loadMonitor(row.id)"
                    >
                    <i class="icon-eye"></i> Show
                    </button>
                    <Loadingcircle
                      :paramloading="paramloading"
                      v-if="stats[row.id] === undefined && loading && statsSelected == row.id" />

                    <ItemMonitor
                      v-if="stats[row.id] !== undefined"
                      :stats="stats"
                      :type="'campaigns'"
                      :ref="row.id"
                      :user_id="row.id"
                    ></ItemMonitor>
                  </td>
                </tr
              ></template>
            </tbody>
            <tfoot>
              <tr>
                <td class="bg-light" colspan="2">
                  <!-- user -->
                  <h6 v-if="okstat">
                    {{ list[0].client }}
                    <span
                      ><i
                        class="icon-credit-card"
                        :class="
                          list[0].pmc_id == null
                            ? 'badge-danger'
                            : 'badge-success'
                        "
                      ></i
                    ></span>
                  </h6>
                </td>
                <td class="bg-light">
                  <!-- groups-->
                  <small v-if="!total_viewer" class="text-success">
                    <i class="icon-checkmark mr-1"></i>
                  </small>
                  <small v-if="total_viewer" class="badge badge-danger">
                    <i class="icon-eye mr-1"></i>{{ total_viewer }}
                  </small>
                </td>
                <td class="bg-light">
                  <!-- total nylas -->
                  <small v-if="total_nylas" class="badge badge-danger mr-1">
                    <i class="icon-unlink mr-1"></i>{{ total_nylas }}
                  </small>
                  <small v-if="!total_nylas" class="text-success">
                    <i class="icon-checkmark mr-1"></i>
                  </small>
                </td>
                <td class="bg-light">
                  <!-- landing link -->
                  <small v-if="total_calendly" class="badge badge-danger mr-1">
                    <i class="icon-calendar mr-1"></i>{{ total_calendly }}
                  </small>
                  <small v-if="!total_calendly" class="text-success">
                    <i class="icon-checkmark mr-1"></i>
                  </small>
                </td>
                <td class="bg-light">
                  <!-- campaigns -->
                  <div v-if="lines > 0">
                    <span>
                      <i
                        class="icon-checkmark ml-2"
                        title="available contacts"
                      ></i>
                      {{ total_available_contacts }}
                    </span>
                    <span>
                      <i
                        class="icon-user-plus ml-2"
                        title="new contacts per day"
                      ></i>
                      {{ total_quantity_per_day }}
                    </span>
                    <span>
                      <i class="icon-email ml-2" title="new engaged today"></i>
                      {{ total_new_emails_sent_today }}
                    </span>
                    <span>
                      <i class="icon-refresh ml-2" title="follow ups today"></i>
                      {{ total_recurring_emails_sent_today }}
                    </span>
                    <span>
                      <i class="icon-user ml-2" title="total contacts"></i>
                      {{ total_contacts }}
                    </span>
                  </div>
                  <strong class="badge badge-secondary" v-else>
                    No campaigns
                  </strong>
                </td>
                <td class="bg-light">
                  <!-- bounce rate -->
                  <span v-if="lines > 0" class=""
                    >{{ (bounce_total / lines).toFixed(2) }}%</span
                  >
                </td>
                <td class="bg-light">
                  <!-- spam rate -->
                  <span v-if="lines > 0" class=""
                    >{{ (total_spam_rate / lines).toFixed(2) }}%</span
                  >
                </td>
                <td class="bg-light">
                  <!-- answering rate -->
                  <span v-if="lines > 0" class="">
                    {{ (total_answering / lines).toFixed(2) }}%
                  </span>
                </td>
                <td class="bg-light">
                  <!-- meeting rate -->
                  <span v-if="lines > 0" class=""
                    >{{ (total_apoint / lines).toFixed(2) }}%</span
                  >
                </td>
                <td class="bg-light" v-if="false">
                  <!-- avday -->
                  <span v-if="lines > 0" class="">{{
                    total_av.toFixed(2)
                  }}</span>
                </td>
                <td class="bg-light">
                  <!--valid -->
                  <span v-if="lines > 0" class="text-success">{{
                    total_meeting_valid -
                    total_meeting_absent -
                    total_meeting_canceled
                  }}</span>
                </td>
                <td class="bg-light">
                  <!-- no show -->
                  <span v-if="lines > 0" class="text-warning">{{
                    total_meeting_absent
                  }}</span>
                </td>
                <td class="bg-light">
                  <!-- canceled -->
                  <span v-if="lines > 0" class="text-danger">{{
                    total_meeting_canceled
                  }}</span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div v-else>No Records</div>
      </div>
 </section>
</template>

<script>
import {
  monitorService,
  usersService
} from "@/_services";

import { mapState, mapActions } from "vuex";
import Loadingcircle from "@/components/Common/Loadingcircle.vue";
import CampaignProspector from "@/components/Common/CampaignProspector.vue";


import ItemMonitor from "@/components/Dashboard/Monitor/row.vue";

export default {
  props: {
   client_id:false,
   targetId: {
    type: String,
    default: '0'
   }
  },
  components: { ItemMonitor, Loadingcircle, CampaignProspector },
  data() {
    return {
      filtersDash: {},
      okstat:true,
      list:[],
      stats:[],
      adminUsers:0,
      userselecteddata: [],
      loading: false,
      lines: 0,
      total_calendly: 0,
      total_nylas: 0,
      total_viewer: 0,
      statsSelected: 0,
      paramloading: {
        width: '28px',
        height: '28px',
        color: '#5054EB'
      },
    };
  },
  computed: {
      ownerCalendar() {
        return (emailSincronized) => {
          if (emailSincronized) {
            const user = this.list.find(
              (el) =>
                el.nylas_calendar_email_sync === emailSincronized &&
                (el.role_id == 3 || el.role_id == 4) &&
                el.nylas_email_sync_status == 1
            );
            if (user) {
              return `${user.name} ${user.lastname}`;
            } else {
              return null;
            }
          } else {
            return null;
          }
        };
      },

  },
  created() {
    this.filtersDash.getEmailTeam = true;
    this.filtersDash.getGraphData = false;

  },
  mounted() {
    if(this.targetId != '0'){
      this.okstat = false;
      this.filterNow();
    }
  },
    methods: {

    warmupDays(date) {
      var date1 = new Date(date);
      var date2 = new Date();

      // To calculate the time difference of two dates
      var days = parseInt(
        (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)
      );
      return days;
    },
      getCalendarLink(domain, id) {
        let sales_id = btoa(id);
        return "https://" + domain + "/calendar/" + sales_id;
      },
      isOliverCalendar(link) {
        if (link && link.includes("/calendar/")) {
          return true;
        }
        return false;
      },
      getOwarmClass(row) {
        let owClass = "";
        switch (row.owarm_status_id) {
          case "1":
            owClass = "btn-warning";
            break;
          case "2":
            owClass = "btn-success";
            break;
          case "3":
            owClass = "btn-danger";
            break;
        }
        return "badge cursor-pointer " + owClass;
      },
      getClassUserStatus(id) {
        switch (id) {
          case "1":
            return "badge-success";
          case "2":
            return "badge-secondary";
          case "3":
            return "badge-danger";
          case "4":
            return "badge-warning";
        }
      },
      filterNow(filter) {
        this.graphsData = [];
        this.cardData = {};
        this.okstat = false;
        if (filter != undefined) {
          this.filtersDash = filter;
          this.filtersDash.getGraphData = false;
        }
        this.filtersDash.withDomain = false;
        this.list = [];
        monitorService
          .getMonitorList(this.client_id, this.filtersDash, this.targetId)
          .then((result) => {
            if (result.length == 0) {
              this.okstat = true;
               this.graphsDataLoading = false;
            } else {
              this.list = result;
              //this.filterNowGraphData();
              //this.dataTarget();
              // this.loadMonitors(result);
              this.okstat = true;
              this.adminUsers++;
            }
          });
      },
      loadMonitor(id){
        this.statsSelected = id;
        this.loading = true;
        monitorService
          .getMonitorUser(id, "stats")
          .then((result2) => {
            console.log('result2.....', result2)
            this.stats[id] = result2;
            //this.stats.push(result2)
            // cantstats++;
            // if (cantstats >= this.list.length - this.otherUsers) {
            //   this.loadTotals();
            // }
            this.loading = false;
            this.statsSelected = 0;
          })
          .then((r) => {
            this.okstat = true;
            this.$forceUpdate();
          });

          this.$forceUpdate();
      },
      loadMonitors(results) {
        let cantstats;
        cantstats = 0;
        results.forEach((result) => {
          if (result.role_id != "2") {
            this.otherUsers++;
            return true;
          } else {
            this.adminUsers++;
          }
          monitorService
            .getMonitorUser(result.id, "stats")
            .then((result2) => {
              this.stats[result.id] = result2;
              cantstats++;
              if (cantstats >= this.list.length - this.otherUsers) {
                this.loadTotals();
              }
            })
            .then((r) => {
              this.okstat = true;
              this.$forceUpdate();
            });
        });
        this.okstat = true;
      },
      dataTarget(){
        usersService.getGroupList(this.client_id).then(result => {
            this.dataUsers = result;
            this.list.forEach( el => {
              const targets = result.find( e => e.id === el.id)
              if(targets) el.targets = targets.targets
            })
            this.loadingteam = false;
          });
      },
      filterNowGraphData() {
        this.filtersDash.getGraphData = true;
        monitorService
          .getMonitorList(this.client_id, this.filtersDash)
          .then((result) => {
            if (result) {
              this.graphsData = [];
              this.cardData = {};
              Object.entries(result).forEach((value, index) => {
                if (value[1].graph_type != "pie") {
                  this.cardData[value[0]] = value[1].data;
                  return;
                }

                if (value[1].data[0].label == null) {
                  return;
                }

                let graphsDataN = {
                  labels: [],
                  datasets: [{ data: [], backgroundColor: [] }],
                  options: {
                    cutoutPercentage: 10,
                    responsive: true,
                    aspectRatio: 1,
                    maintainAspectRatio: false,
                    devicePixelRatio: 2,
                    title: {
                      display: true,
                      text: this.$t("lang.column." + value[0]),
                      innerText: "",
                    },
                    legend: {
                      display: false,
                    },
                  },
                };
                value[1].data.forEach((item, index2) => {
                  graphsDataN.labels.push(item.label);
                  var randomColor = Math.floor(Math.random() * 16777215).toString(
                    16
                  );
                  graphsDataN.datasets[0].backgroundColor.push("#" + randomColor);
                  graphsDataN.datasets[0].data.push(item.total);
                });
                this.graphsData.push(graphsDataN);
              });

              //('cardData', this.cardData);
              this.graphsDataLoading = false;
            }
          });
        this.filtersDash.getGraphData = false;
      },

        connectSpark(user) {
      if (user.provider == "gmail") {
        var scopes = [
          //"https://www.googleapis.com/auth/gmail.readonly",
          "https://www.googleapis.com/auth/userinfo.profile",
          "https://www.googleapis.com/auth/gmail.modify",
          "https://www.googleapis.com/auth/userinfo.email",
          "https://www.googleapis.com/auth/gmail.labels",
          "https://www.googleapis.com/auth/calendar",
        ];
        // var redirect_uri = "https://oliver-api.localhost.com/oauth/callback";
        //var redirect_uri = "https://app.oliverlist.com/dashboard";
        var redirect_uri = process.env.VUE_APP_FRONT_URL + "/dashboard";
        //console.log(redirect_uri);
        var client_id =
          "679504478551-85b7vh81acj9h8176g9fmpo0pomicgl3.apps.googleusercontent.com";
        var scope = scopes.join(" ");
        var auth_url = "https://accounts.google.com/o/oauth2/auth";
        auth_url += "?redirect_uri=" + encodeURIComponent(redirect_uri);
        auth_url += "&client_id=" + encodeURIComponent(client_id);
        auth_url += "&scope=" + encodeURIComponent(scope);
        auth_url += "&approval_prompt=force";
        auth_url += "&access_type=offline";
        auth_url += "&response_type=code";
        auth_url += "&login_hint=" + user.nylas_email_sync;

        window.open(auth_url, "_blank");
      } else {
        let client_id = "0d136df4-3c69-4c23-b7b9-54217c864e0c"; //APP OLIVER
        let redirect_uri = process.env.VUE_APP_FRONT_URL + "/dashboard";
        let scope =
          "Calendars.Read.Shared Calendars.ReadWrite Calendars.ReadWrite.Shared Contacts.Read Contacts.ReadWrite Mail.Read Mail.ReadWrite Mail.Send OnlineMeetings.ReadWrite  User.Read profile openid offline_access";
        let state = Math.random().toString(36).substring(7);
        let auth_url =
          "https://login.microsoftonline.com/common/oauth2/v2.0/authorize" +
          "?client_id=" +
          encodeURIComponent(client_id) +
          "&response_type=code" +
          "&redirect_uri=" +
          encodeURIComponent(redirect_uri) +
          "&scope=" +
          encodeURIComponent(scope) +
          "&state=" +
          encodeURIComponent(state) +
          "&login_hint=" +
          user.nylas_email_sync;

        window.open(auth_url, "_blank");
      }
    },

    }
};
</script>
